import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';
var AdmManageProctorTeamLeadService = (function () {
    function AdmManageProctorTeamLeadService(_httpClient) {
        this._httpClient = _httpClient;
    }
    // TODO : Need to update urls Name after changes in APIs side
    AdmManageProctorTeamLeadService.prototype.getData = function (params) {
        return this._httpClient.get(AppUrl.getProctorDetail, params);
    };
    AdmManageProctorTeamLeadService.prototype.getProctorNames = function (param) {
        return this._httpClient.get(AppUrl.getProctorNames, param);
    };
    AdmManageProctorTeamLeadService.prototype.getGroups = function () {
        return this._httpClient.get(AppUrl.getProctorGroups);
    };
    AdmManageProctorTeamLeadService.prototype.getOffice = function () {
        return this._httpClient.get(AppUrl.getOfficeDetail);
    };
    Object.defineProperty(AdmManageProctorTeamLeadService.prototype, "groupList", {
        get: function () {
            return this.groupData;
        },
        set: function (data) {
            this.groupData = data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdmManageProctorTeamLeadService.prototype, "proctorLeadList", {
        get: function () {
            return this.proctorLeadData;
        },
        set: function (data) {
            this.proctorLeadData = data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdmManageProctorTeamLeadService.prototype, "proctorList", {
        get: function () {
            return this.proctorData;
        },
        set: function (data) {
            this.proctorData = data;
        },
        enumerable: true,
        configurable: true
    });
    return AdmManageProctorTeamLeadService;
}());
export { AdmManageProctorTeamLeadService };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-proctor-team-lead/adm-manage-proctor-team-lead.service.ts.pre-build-optimizer.js